import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import useLocaleFormat from "~/hooks/useLocaleFormat";

const useRelativeTimestamp = (): ((timestamp: string) => string) => {
	const { t } = useTranslation("common");
	const fmt = useLocaleFormat();
	return useCallback(
		(timestamp: string) => fmt.formatRelativeTimestamp(timestamp, { justNow: t("relativeTimestamp.justNow") }),
		[fmt, t]
	);
};

export default useRelativeTimestamp;
